// extracted by mini-css-extract-plugin
module.exports = {"fade":"SkUia","show":"__9Qi8Z","collapse":"JaTmH","collapsing":"eeFtU","collapsing-horizontal":"als32","collapse-only-mobile":"t68_S","collapse-only-desktop":"f3A9H"};